export default __webpack_public_path__ + "static/media/bloodDonation.790bfea5.svg";